import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';

export function PractitionerOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user } = useSelector((state: RootState) => state.auth);
  const userType = (user as any)?.userType as 'ADMIN' | 'PRACTITIONER' | undefined;

  if (userType === 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export default PractitionerOnlyRoute;

